import { createSlice } from "@reduxjs/toolkit";

const initialLanguages = [
  {
    key: "tr-tr",
    value: "Türkçe",
  },
  {
    key: "en-us",
    value: "English(us)",
  },
  {
    key: "en-gb",
    value: "English(uk)",
  },
  {
    key: "ar-sa",
    value: "Arabic",
  },
  {
    key: "az-az",
    value: "Azerbaijani",
  },
  {
    key: "bg-bg",
    value: "Bulgarian",
  },
  {
    key: "bs-ba",
    value: "Bosnian",
  },
  {
    key: "cs-cz",
    value: "Czech",
  },
  {
    key: "da-dk",
    value: "Danish",
  },
  {
    key: "de-at",
    value: "German (Austria)",
  },
  {
    key: "de-de",
    value: "German",
  },
  {
    key: "el-gr",
    value: "Greek",
  },
  {
    key: "es-es",
    value: "Spanish",
  },
  {
    key: "et-ee",
    value: "Estonian",
  },
  {
    key: "fi-fi",
    value: "Finnish",
  },
  {
    key: "fr-fr",
    value: "French",
  },
  {
    key: "he-il",
    value: "Hebrew",
  },
  {
    key: "hu-hu",
    value: "Hungarian",
  },
  {
    key: "id-id",
    value: "Indonesian",
  },
  {
    key: "it-it",
    value: "Italian",
  },
  {
    key: "ka-ge",
    value: "Georgian",
  },
  {
    key: "ky-kz",
    value: "Kyrgyz",
  },
  {
    key: "lt-lt",
    value: "Lithuanian",
  },
  {
    key: "lv-lv",
    value: "Latvian",
  },
  {
    key: "mk-mk",
    value: "Macedonian",
  },
  {
    key: "mn-mn",
    value: "Mongolian",
  },
  {
    key: "nl-be",
    value: "Dutch (Belgium)",
  },
  {
    key: "nl-nl",
    value: "Dutch",
  },
  {
    key: "no-nb",
    value: "Norwegian",
  },
  {
    key: "pt-pt",
    value: "Portuguese",
  },
  {
    key: "ru-ru",
    value: "Russian",
  },
  {
    key: "sk-sk",
    value: "Slovak",
  },
  {
    key: "sq-al",
    value: "Albanian",
  },
  {
    key: "srm-xs",
    value: "Saramaccan",
  },
  {
    key: "sv-se",
    value: "Swedish",
  },
  {
    key: "th-th",
    value: "Thai",
  },
  {
    key: "vi-vn",
    value: "Vietnamese",
  },
  {
    key: "pl-pl",
    value: "Polish",
  },
  {
    key: "sl-sl",
    value: "Slovenian",
  },
  {
    key: "ua-ua",
    value: "Ukranian",
  },
  {
    key: "sq-xk",
    value: "Kosovo",
  },
  {
    key: "ro-ro",
    value: "Romanian",
  },
  {
    key: "cn-sc",
    value: "Chinese (Simplified)",
  },
  {
    key: "cn-tc",
    value: "Chinese (Traditional)",
  },
];

const localizationSlice = createSlice({
  name: "localization",
  initialState: {
    languages: initialLanguages.sort((a, b) => a.value.localeCompare(b.value)),
    contentLocalization: {},
    countries: [],
    isCountrySelectModalOpen: false,
    countryDefaultLanguageCode: "",
  },
  reducers: {
    setContentLocalization(state, action) {
      if (state.contentLocalization !== action.payload) {
        state.contentLocalization = action.payload;
      }
    },
    setCountries(state, action) {
      const savedCountries = action.payload;
      // Store normalized values with defaultLanguage for Select components
      const normalizedValues = savedCountries.map((country) => {
        return {
          key: country.countryName,
          value: country.countryName,
          countryCode: country.countryCode,
          defaultLanguage: country.defaultLanguage,
        };
      });
      state.countries = normalizedValues;
    },
    setLanguage(state, action) {
      state.contentLocalization.language = action.payload;
    },
    setIsCountrySelectModalOpen(state, action) {
      state.isCountrySelectModalOpen = action.payload;
    },
    setCountryDefaultLanguageCode(state, action) {
      state.countryDefaultLanguageCode = action.payload;
    },
  },
});

export const localizationActions = localizationSlice.actions;
export default localizationSlice;
